import { createContext, useContext, useState } from 'react';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
    const [categories, setCategories] = useState([]);
    const [categoryId, setCategoryId] = useState('');
    const [sectionId, setSectionId] = useState('');
    const [subSectionLevel1Id, setSubSectionLevel1Id] = useState('');
    const [subSectionLevel1Name, setSubSectionLevel1Name] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [isSearchLoading, setIsSearchLoading] = useState(false);
    const [userData, setUserData] = useState(null);
    const [isWrapper, setIsWrapper] = useState(false);
    const [searchArticleResults, setSearchArticleResults] = useState([
        {
            articleTitle: 'title',
            articleSummary: 'summary',
            articleSubSection: 'sub section name',
        },
    ]);
    const [isFoxtelCssAttached, setIsFoxtelCssAttached] = useState(false);

    return (
        <AppContext.Provider
            value={{
                categories,
                setCategories,
                categoryId,
                setCategoryId,
                sectionId,
                setSectionId,
                subSectionLevel1Id,
                setSubSectionLevel1Id,
                subSectionLevel1Name,
                setSubSectionLevel1Name,
                searchArticleResults,
                setSearchArticleResults,
                searchQuery,
                setSearchQuery,
                userData,
                setUserData,
                isSearchLoading,
                setIsSearchLoading,
                isWrapper,
                setIsWrapper,
                isFoxtelCssAttached,
                setIsFoxtelCssAttached
            }}
        >
            {children}
        </AppContext.Provider>
    );
};

// Custom hook for easier access
export const useAppContext = () => useContext(AppContext);
